// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"395":"9077b474","735":"e18f8059","951":"8d32270c"}[chunkId] + ".css";
};